import React from 'react';


const NudeNewsPrivacyPolicy = () => (
  <div className="content">
    <div className="container">
      <h1 className="h3">Nude News Privacy Policy</h1>
      <small>Effective Date: May 25, 2018</small>
      <p>
        To view our previous Privacy Policy,{' '}
        <a href="/privacy_policy?archive=20130904">
          click here
        </a>
        .
      </p>
      <ol>
        <li>
          <a href="/privacy_policy#s1">Introduction</a>
        </li>
        <li>
          <a href="/privacy_policy#s2">
            Information we collect
          </a>
        </li>
        <li>
          <a href="/privacy_policy#s3">
            How we use the information we collect
          </a>
        </li>
        <li>
          <a href="/privacy_policy#s4">
            How we share the information we collect
          </a>
        </li>
        <li>
          <a href="/privacy_policy#s5">
            Cookies and other tracking technologies
          </a>
        </li>
        <li>
          <a href="/privacy_policy#s6">
            Information collected by third parties
          </a>
        </li>
        <li>
          <a href="/privacy_policy#s7">Email opt-out</a>
        </li>
        <li>
          <a href="/privacy_policy#s8">
            Credit card processing
          </a>
        </li>
        <li>
          <a href="/privacy_policy#s9">Security</a>
        </li>
        <li>
          <a href="/privacy_policy#s10">
            Children and COPPA compliance
          </a>
        </li>
        <li>
          <a href="/privacy_policy#s11">
            Business transitions
          </a>
        </li>
        <li>
          <a href="/privacy_policy#s12">
            California users consumer rights
          </a>
        </li>
        <li>
          <a href="/privacy_policy#s13">
            Users located outside of the United States
          </a>
        </li>
        <li>
          <a href="/privacy_policy#s14">
            EU users' rights under the GDPR
          </a>
        </li>
        <li>
          <a href="/privacy_policy#s15">Data retention</a>
        </li>
        <li>
          <a href="/privacy_policy#s16">
            Cooperation with law enforcement; fraud
            protection
          </a>
        </li>
        <li>
          <a href="/privacy_policy#s17">
            Changes to this Privacy Policy
          </a>
        </li>
        <li>
          <a href="/privacy_policy#s18">Who we are</a>
        </li>
      </ol>
      <a name="s1" />
      <p className="h4">1. Introduction</p>
      <p>
        Please read the following policy to understand how
        your personal information will be treated as you
        make full use of our Website. When we talk about our
        Website or our Service, we are referring to this
        website, any corresponding mobile application and
        any services provided by us through such website
        and/or application. When we talk about "we", ''our''
        or ''us'' in this policy, we are referring to
        Playboy.com, Inc., the company that provides the
        Website and Service. If you have any questions,
        concerns or complaints related to this Privacy
        Policy or our processing of your personal
        information, please email us here:{' '}
        <a href="mailto:privacy@playboy.com">
          privacy@playboy.com
        </a>
        . This email address is monitored on a regular basis
        and we aim to respond to your query as soon as
        possible.
      </p>
      <p>The Privacy Policy has three main purposes:</p>
      <ol>
        <li>
          Explain the way we use information that you
          share with us in order give you a great
          experience with our Website;
        </li>
        <li>
          Ensure that you understand what information we
          collect with your permission, what we do with it
          and with whom we share it; and
        </li>
        <li>Explain your rights under applicable law.</li>
      </ol>
      <p>
        All the information we collect is related to
        providing our Website or Service. By agreeing to our
        Privacy Policy, you give us the right to collect
        your information as detailed in this Privacy Policy
        and use it for the purposes described in this
        Privacy Policy. IF YOU DON'T AGREE WITH THE TERMS OF
        THIS PRIVACY POLICY, THEN PLEASE DON'T USE THE
        WEBSITE OR SERVICE.
      </p>
      <a name="s2" />
      <p className="h4">2. Information we collect</p>
      <p>
        The information we collect can be divided into the
        following broad categories:
      </p>
      <ul>
        <li>
          Technical Data includes internet protocol (IP)
          address, your login data, device type, device
          version, browser type and version, browser
          plug-ins types, time zone setting and location,
          traffic data, search criteria, weblogs and other
          communications data, operating system and
          platform and other technology on the devices you
          use to access the Website.
        </li>
        <li>
          Usage Data includes information about how you
          use our Website or Service, such as the
          particular pages you interact with, how often
          you visit, how long you're on the Website,
          surveys, the service you're looking, your
          preference ratings, at and the emails you
          interact with.
        </li>
        <li>
          Verification Data includes proof of identity and
          proof of address as further detailed in our{' '}
          <a
            href="data:application/pdf;base64,JVBERi0xLjQKMSAwIG9iago8PAovVGl0bGUgKP7/KQovQ3JlYXRvciAo/v8p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"
            rel="noreferrer" target="_blank"
          >
            Subject Access Request Form
          </a>
          .
        </li>
        <li>
          Financial Data includes payment card details you
          provide, including expiration date. It also
          includes details about your payment history and
          services or products you have purchased from us.
        </li>
        <li>
          Identity Data includes email address, username
          and password, and for subscribers, full name,
          billing address.
        </li>
      </ul>
      <p>
        More specifically, we may collect and store the
        following information relating to you:
      </p>
      <a name="s2.1" />
      <p className="h5">2.1 Anonymous data</p>
      <p>
        When you visit our Website, we collect some basic
        information that does not identify individual users.
        This includes which pages are visited and any
        feedback from our visitors. We then aggregate this
        information with other pieces of information to
        improve our Website and make your experience on the
        Website as valuable and efficient as possible. We
        may also collect and accumulate anonymous data that
        will help us understand and analyze the online
        experience of our Website users. For instance, we
        may accumulate visitor data relating to referring
        domain names, the type of browsers used, operating
        system software, screen resolutions, color
        capabilities, browser plug-ins, language settings,
        cookie preferences, search engine keywords and
        JavaScript enablement.
      </p>
      <a name="s2.2" />
      <p className="h5">  2.2 Direct Interactions       </p>
      <p>
        We collect information from you when you voluntarily
        submit information directly to us or via our
        Website. For members, this refers to personal data
        you provide when, for example, you create an
        account, complete a profile, or by corresponding
        with us via phone, email or live chat. This personal
        information may include name, age, address, phone
        and email, as necessary to set up your account. If
        you connect to the Website using credentials from a
        third-party application (e.g., Facebook), you
        authorize us to collect your authentication
        information, such as your username and encrypted
        access credentials. We may also collect other
        information available on or through your third-party
        application account, including, for example, your
        name, profile picture, country, hometown, email
        address, date of birth, gender, friends' names and
        profile pictures, and networks.
      </p>
      <p>
        You may decide to provide us with another person's
        contact information so that person may be invited to
        join our Service or so that we may facilitate your
        communication with other people through the Service
        (such as when you upload an address book or a
        contact list). You may also provide us with another
        person's contact information for purposes of
        delivering information through social networking
        applications. We store the information that you
        provide so that the respondents may be added to your
        network, and also to send reminders of the
        invitations. All invitees are provided with the
        option not to receive further invitations from us.
      </p>
      <p>
        In addition to the information we may collect upon
        your initial registration, we may ask you for
        personal information at other times. We will not
        share that information in a manner that identifies
        you as an individual with any other entity unless we
        have your permission.
      </p>
      <a name="s2.3" />
      <p className="h5">
        2.3 Information submitted by you for inclusion on
        the Website
      </p>
      <p>
        Please remember that if you post any of your
        personal information in public areas of the Website,
        such as in online forums or chat rooms, such
        information may be collected and used by others over
        whom we have no control. We are not responsible for
        the use made by third parties of information you
        post or otherwise make available in public areas of
        the Website. You should take care to not use
        personal information in your screen name or other
        information that might be publicly available to
        other users.
      </p>
      <a name="s2.4" />
      <p className="h5">2.4 Tracking technologies</p>
      <p>
        We use "cookies" and similar tracking technologies
        (as described in{' '}
        <a href="/privacy_policy#s5">Section 5</a> below and
        in our <a href="/cookie-policy">Cookie Policy</a>)
        to track your activities on our Website, and may
        also receive data about you if you visit other
        websites employing our cookies. When we send you
        emails that include a link to the Website, that link
        may contain an alphanumeric identifier that allows
        us to identify the person to whom we sent the
        message so that we can personalize our content for
        that individual.
      </p>
      <a name="s2.5" />
      <p className="h5">
        2.5 Automated technologies or interactions
      </p>
      <p>
        As you interact with our Website, we may
        automatically collect technical and usage data about
        your device, browsing actions and patterns. For
        example, we collect information which may include
        your IP address, browser type, your location,
        language preferences, device information and access
        times. While an IP address does not identify an
        individual by name, it may, with the cooperation of
        the ISP, be used to locate and identify an
        individual. Your IP address can reveal what
        geographic area you are connecting from, or which
        ISP you are using. Finally, other websites you visit
        have IP addresses, and we may collect the IP
        addresses of those websites and their pages. We also
        collect IP addresses for system administration and
        to report aggregate information to any sponsors. We
        may also receive information from our web logs,
        which automatically record anything a web server
        sees, which may include email addresses you enter
        into a form or pages viewed by a user at a
        particular IP address. We collect this personal data
        by using cookies, pixel tags and other similar
        tracking technologies. The sole purpose of passively
        collecting your information is to improve your
        experience when using our Website.
      </p>
      <a name="s2.6" />
      <p className="h5">2.6 Payment data</p>
      <p>
        If you purchase a subscription to our Service or
        make other purchases through the Website, your
        credit or debit card information (such as card type
        and expiration date) and other financial data that
        we need to process your payment may be collected and
        stored by us and/or the payment processors with
        which we work. We may also collect some limited
        information, such as your postal code, mobile
        number, and details of your transaction history, all
        of which are necessary to process your purchase. In
        addition, the payment processors generally provide
        us with some limited information related to you,
        such as a unique token that enables you to make
        additional purchases using the information they've
        stored, and your card's type, expiration date, and
        certain digits of your card number.
      </p>
      <a name="s2.7" />
      <p className="h5">2.7 Promotions &amp; surveys</p>
      <p>
        From time to time, we may offer you the opportunity
        to participate in promotions such as sweepstakes,
        contests, offers, and/or surveys ("Special
        Promotions") through the Service. A Special
        Promotion may be governed by a privacy policy and/or
        terms and conditions that are additional to, or
        separate from, this Privacy Policy and our{' '}
        <a href="/terms_of_service">Terms of Use</a>. If the
        provisions of the Special Promotion's privacy policy
        or terms and conditions conflict with this Privacy
        Policy or our{' '}
        <a href="/terms_of_service">Terms of Use</a>, those
        additional or separate provisions shall prevail. If
        you participate in a Special Promotion, we may ask
        you for certain information in addition to what is
        stated in this Privacy Policy, including personal
        information. That additional information may be
        combined with other account information and may be
        used and shared as described in this Privacy Policy
        or in the Special Promotion.
      </p>
      <a name="s2.8" />
      <p className="h5">
        2.8 Information received from our service providers
        and partners
      </p>
      <p>
        We may also receive information about you from our
        service providers and partners, which we use to
        personalize our Service, to measure ad quality and
        responses to ads, to display ads that are more
        likely to be relevant to you, and to offer you
        opportunities to purchase products or services that
        we believe may be of interest to you.
      </p>
      <a name="s3" />
      <p className="h4">
        3. How we use the information we collect
      </p>
      <p>
        We have set out below, in a table format, a
        description of all the ways we process your personal
        data, and the legal basis we rely on to do so.
      </p>
      <table className="table-striped table-condensed">
        <thead>
          <tr>
            <th>Purpose/Activity</th>
            <th width={300}>Type of Data</th>
            <th width={200}>Legal Basis</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>To allow you to visit the Website</td>
            <td>Technical Data , Usage Data</td>
            <td>Consent</td>
          </tr>
          <tr>
            <td>To allow you to create an account</td>
            <td>Identity Data, Usage Data</td>
            <td>Consent</td>
          </tr>
          <tr>
            <td>
              To register you as a paid member and
              process renewal of your membership
            </td>
            <td>Financial Data , Identity Data</td>
            <td>Consent</td>
          </tr>
          <tr>
            <td>
              To manage our relationship with you. For
              example general enquiries such as how
              the Website works, complaints and
              payment queries
            </td>
            <td>
              Any data you choose to share with us or
              request us to view
            </td>
            <td>Consent</td>
          </tr>
          <tr>
            <td>
              To administer and protect the Website
              (including troubleshooting, fraud
              prevention, spam prevention, security
              incident prevention and correction, data
              analysis, testing, system maintenance,
              support, reporting and hosting of data),
              operate the Website (including notifying
              you of any changes), optimize your user
              experience, and send you service and
              support messages such as updates,
              patches and security alerts
            </td>
            <td>
              Financial Data , Identity Data ,
              Technical Data , Usage Data
            </td>
            <td>Consent</td>
          </tr>
          <tr>
            <td>
              To send you promotional messages,
              marketing, advertising and other such
              information we think may be of interest
              to you, either directly or through one
              of our partners; you may opt out from
              receiving certain messages, as described
              in{' '}
              <a href="/privacy_policy#s7">
                Section 7
              </a>
            </td>
            <td>
              Financial Data , Identity Data ,
              Technical Data , Usage Data
            </td>
            <td>Consent</td>
          </tr>
          <tr>
            <td>
              To enable you to partake in a prize
              draw, competition, referral scheme,
              rewards program, promotional activities,
              events, complete a survey or invite you
              to participate in Website testing
            </td>
            <td>
              Financial Data Identity Data Technical
              Data
            </td>
            <td>Consent</td>
          </tr>
          <tr>
            <td>
              To analyze your use of the Website and
              deliver relevant website content and
              third-party advertisements, for example
              by providing customized, personalized,
              or localized content, recommendations,
              features, and advertising.
            </td>
            <td>Usage Data</td>
            <td>Consent</td>
          </tr>
          <tr>
            <td>
              To enable third parties to advertise
              products or services in which you may be
              interested, including via emails
            </td>
            <td>
              Identity Data,  Usage Data,  Technical
              Data
            </td>
            <td>Consent</td>
          </tr>
          <tr>
            <td>
              To enforce this Privacy Policy,
              our&nbsp;
              <a href="/terms_of_service">
                Terms of Use
              </a>
              , and any other terms that you have
              agreed to, including to protect the
              rights, property, or safety of our
              users, or any other person, or the
              copyright-protected content of the
              Website
            </td>
            <td>
              Identity Data , Usage Data,  Technical
              Data
            </td>
            <td>
              For purposes of legitimate interests
            </td>
          </tr>
          <tr>
            <td>
              To maintain and retain records in
              connection with actual and potential
              legal claims and regulatory
              investigations; and for governance &amp;
              compliance purposes
            </td>
            <td>
              Financial Data , Identity Data , Usage
              Data,  Technical Data
            </td>
            <td>
              Necessary for the compliance with a
              legal obligation to which we are subject
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        We will only use your personal data for the purposes
        for which we collected it, unless we reasonably
        consider that we need to use it for another reason,
        and that reason is compatible with the original
        purpose.
      </p>
      <p>
        Please note that we may process your personal data
        without your knowledge or consent, in compliance
        with the above rules, where this is required or
        permitted by law.
      </p>
      <a name="s4" />
      <p className="h4">
        4. How we share the information we collect
      </p>
      <p>
        This section describes how the information collected
        or generated through your use of the Website may be
        shared by us with third parties.
      </p>
      <a name="s4.1" />
      <p className="h5">4.1 Marketing and advertising</p>
      <p>
        We share information with advertising partners in
        order to send you promotional communications about
        our Website or to show you more tailored content,
        including relevant advertising for third-party
        products and services that may be of interest to
        you, and to understand how users interact with
        advertisements. We also share personally
        identifiable information with third-party
        advertisers to enable them to provide you with
        opportunities to learn of products or services in
        which you may be interested.
      </p>
      <p>
        We may also share aggregate user information in a
        non-personally identifiable manner with advertisers
        and other third parties in order to present to users
        more targeted advertising, products and services.
      </p>
      <a name="s4.2" />
      <p className="h5">4.2 Service providers</p>
      <p>
        We may from time to time share your information with
        third-party service providers to perform functions
        and process user data and help provide our Website
        or Service, consistent with this Privacy Policy. For
        example, we work with analytics providers to help us
        understand the use of our Website. Where a third
        party processes user data on our behalf, it is
        subject to security and confidentiality obligations
        consistent with this Privacy Policy and applicable
        law; we only permit them to process your personal
        data for specified purposes and in accordance with
        our instructions. Where a third party processes user
        data on its own behalf, its processing is subject to
        its own Privacy Policy and applicable law.
      </p>
      <p>
        To provide you with the best experience on our
        Website, we use third parties who automatically
        process your Usage Data on our behalf. Where
        possible, we will make sure this data is anonymized.
      </p>
      <p>
        For your information,{' '}
        <a href="/privacy_policy/3rd-parties">click here</a>{' '}
        to view some examples of how third parties process
        your personal data.
      </p>
      <a name="s4.3" />
      <p className="h5">4.3 Affiliate networks</p>
      <p>
        If you access our Website through an offer that you
        received or purchased from a third party, we may
        also share information with that third party about
        your use of the Website, such as whether and to what
        extent you have used the offer, activated an
        account, or actively used our Service.
      </p>
      <a name="s4.4" />
      <p className="h5">4.4 Promotions and surveys</p>
      <p>
        When one or more of our business partners co-sponsor
        a service, promotion, contest/sweepstakes, or
        survey, we may share some or all of the information
        collected in connection with such service,
        promotion, contest/sweepstakes, or survey with the
        co-sponsor(s). If we intend to share such
        information, you will be notified prior to the
        collection of that information. If you do not want
        your information to be shared, you will be able to
        choose not to allow the transfer by not using or
        signing up for that particular service, promotion,
        contest/sweepstakes, or survey.
      </p>
      <a name="s5" />
      <p className="h4">
        5. Cookies and other tracking technologies
      </p>
      <p>
        A cookie is a small text file that is placed on your
        computer, mobile phone, or other device when you
        visit a website. The cookie will help website
        providers to recognize your device the next time you
        visit their website. There are other similar
        technologies such as pixel tags (transparent graphic
        images placed on a web page or in an email, which
        indicate that a page or email has been viewed), web
        bugs (similar to pixel tags), and web storage, which
        are used in desktop software or mobile devices.
      </p>
      <p>
        There are also technologies such as mobile device
        identifiers and SDK integrations to help companies
        recognize your device when you return to an app or
        otherwise use a service.
      </p>
      <p>
        Our policy regarding cookies can be{' '}
        <a href="/cookie-policy">found here</a>.
      </p>
      <a name="s6" />
      <p className="h4">
        6. Information collected by third parties
      </p>
      <p>
        Some entities that have links on our Website, such
        as advertisers, may collect personally identifying
        information about you when you access or utilize
        those links. We do not control the collection or use
        of such information, and the practices of those
        entities are not covered by this Privacy Policy. For
        instance, if you click on an advertisement on our
        Website, you may be taken away to an entirely
        different site. Links can be from advertisers,
        content providers and/or partners who may use our
        logo and/or style as a result of a co-branding
        agreement yet they may still not follow the same
        policies as this Privacy Policy with respect to
        collection of your personal information. In
        addition, our Website includes social media
        features, such as the Facebook Like button. These
        features may collect your IP address, which page you
        are visiting on our Website, and may set a cookie to
        enable the feature to function properly. Social
        media features and related widgets are either hosted
        by a third party or hosted directly on our Website.
        Your interactions with these features are governed
        by the privacy policy of the company providing them.
      </p>
      <p>
        Please read these third parties' privacy policies to
        find out how they collect and process your personal
        information. 
      </p>
      <a name="s7" />
      <p className="h4">7. Email Opt-out</p>
      <p>
        Users who no longer wish to receive our email
        updates or other notifications may opt out of
        receiving these communications by following the
        instructions contained in the applicable email or by
        logging in and changing their account settings.
        Please know that such a decision will not stop
        advertising or content that is generated prior to
        the time when we can accomplish the removal of your
        information.
      </p>
      <a name="s8" />
      <p className="h4">8. Credit Card Processing</p>
      <p>
        Credit card transactions are handled by a
        third-party processor that receives credit card
        numbers and other personally identifying information
        only to verify credit card accounts and process
        transactions.
      </p>
      <p>
        Credit card security is an important aspect of the
        online experience. We use encryption technology to
        keep your credit card information safe. To ensure
        that your information is even more secure, once we
        receive your credit card information, it is stored
        on a server that isn't accessible from the Internet.
      </p>
      <p>
        BY ACCEPTING THE PRIVACY POLICY, YOU EXPRESSLY
        AUTHORISE US TO USE AND SHARE WITH CERTAIN TRUSTED
        BUSINESS PARTNERS AND SERVICE PROVIDERS, WHICH MAY
        BE LOCATED OUTSIDE OF THE COUNTRY OF YOUR RESIDENCE
        (INCLUDING COUNTRIES WHICH DO NOT PROVIDE THE SAME
        LEVEL OF PROTECTION FOR THE PROCESSING OF PERSONAL
        DATA AS THE COUNTRY OF YOUR RESIDENCE), THE
        INFORMATION PROVIDED BY YOU TO US, EVEN IF SUCH
        INFORMATION IS COVERED BY LOCAL BANKING SECRECY
        LAWS. YOU ACKNOWLEDGE AND AGREE TO THE IMPORTANCE OF
        SHARING SUCH INFORMATION FOR THE PROCESSING OF YOUR
        PURCHASE(S) AND ALSO AGREE THAT, BY ACCEPTING THIS
        PRIVACY POLICY, WHERE APPLICABLE AND TO THE EXTENT
        PERMITTED BY APPLICABLE LAW, YOU EXPRESSLY WAIVE
        YOUR RIGHTS UNDER SUCH BANK SECRECY LAWS WITH REGARD
        TO US AND ANY TRUSTED BUSINESS PARTNERS AND SERVICE
        PROVIDERS, WHICH MAY BE LOCATED OUTSIDE YOUR COUNTRY
        OF RESIDENCE. THIS CONSENT IS GIVEN FOR THE DURATION
        OF YOUR RELATIONSHIP WITH US.
      </p>
      <a name="s9" />
      <p className="h4">9. Security</p>
      <p>
        We have put in place appropriate security measures
        to prevent your personal data from being
        accidentally lost, altered or disclosed, used or
        accessed in an unauthorized way. In addition, we
        limit access to your personal data to those
        employees, agents, contractors and other third
        parties who have a business need to know it. They
        will only process your personal data on our
        instructions and they are subject to a duty of
        confidentiality. However, the transmission of data
        via the internet is not completely secure and we
        cannot guarantee that unauthorized parties will not
        be able to defeat those measures: unauthorized entry
        or use, hardware or software failure, and other
        factors may compromise the security of our user
        information at any time.
      </p>
      <p>
        We have put in place procedures to deal with any
        suspected personal data breach and will notify you
        and any applicable regulator of a breach where we
        are legally required to do so.
      </p>
      <a name="s10" />
      <p className="h4">10. Children and COPPA compliance</p>
      <p>
        Our site is not directed to children under the age
        of 13 and we do not knowingly collect data relating
        to anyone under the age of 18. We have designed this
        privacy policy in order to comply with the
        Children's Online Privacy Protection Act ("COPPA").
        We will never knowingly collect any personal
        information about children under the age of 13. If
        we obtain actual knowledge that we have collected
        personal information about a child under the age of
        13, that information will be immediately deleted
        from our database. Because we do not collect such
        information, we have no such information to use or
        to disclose to third parties. If a parent believes
        that his or her child has submitted personal
        information to us, he or she can contact us via
        e-mail or postal mail as listed below. We will
        promptly delete the information upon learning that
        it relates to a child under the age of 13. Please
        note that it is possible some of this information
        may remain archived in web logs and back-up archives
        after we delete the information from our active
        database.
      </p>
      <p>
        We believe that parents should supervise their
        children's online activities and consider using
        parental control tools available from online
        services and software manufacturers that help
        provide a kid-friendly online environment. These
        tools can also prevent children from otherwise
        disclosing online their name, address and other
        personal information without parental permission.
      </p>
      <a name="s11" />
      <p className="h4">11. Business transitions</p>
      <p>
        In the event we go through a business transition,
        such as a merger, acquisition by another company, or
        sale of a portion of our assets, users' personal
        information will, in most instances, be part of the
        assets transferred. In such instance, the new owners
        may use your personal data in the same way as set
        out in this Privacy Policy.
      </p>
      <a name="s12" />
      <p className="h4">
        12. California user consumer rights
      </p>
      <p>
        In accordance with California Civil Code Sec.
        1789.3, California resident users are entitled to
        know that they may file grievances and complaints
        with California Department of Consumer Affairs, 400
        R Street, STE1080, Sacramento, CA 95814; or by phone
        at 916-445-1254 or 800-952-5210; or by email to
        dca@dca.ca.gov. California Civil Code Section
        1798.83 also permits users who are California
        residents to request and obtain from us once a year,
        free of charge, a list of the third parties to whom
        we disclosed their personal data (if any) for direct
        marketing purposes in the preceding calendar year
        and the categories of data disclosed to those third
        parties. To make any sort of access request, please
        write to the following address: Playboy.com, Inc.,
        Privacy Rights, 10960 Wilshire Blvd #2200 Los
        Angeles, CA 90024.
      </p>
      <a name="s13" />
      <p className="h4">
        13. Users located outside of the United States
      </p>
      <p>
        We make an effort to protect the personal
        information of all users of our Website. If you are
        unsure whether this privacy policy is in conflict
        with the rules applicable where you are located, you
        should not submit your personal information. IN
        ADDITION, IF YOU ARE LOCATED WITHIN THE EUROPEAN
        UNION, YOU SHOULD NOTE THAT YOUR INFORMATION WILL BE
        TRANSFERRED TO THE UNITED STATES, THE LAWS OF WHICH
        MAY BE DEEMED BY THE EUROPEAN UNION TO HAVE
        INADEQUATE DATA PROTECTION. Users of our Website
        located in countries outside of the United States
        who submit personal information do thereby consent
        to the transfer of that information to and/or
        storage of the information in the United States.
      </p>
      <a name="s14" />
      <p className="h4">
        14. EU users' rights under the GDPR
      </p>
      <p>
        If you are located in the European Union, or if the
        EU's General Data Protection Regulation ("GDPR")
        otherwise applies to your data as processed by us,
        you have the right to:
      </p>
      <ol>
        <li>
          request access to your personal data. This
          enables you to receive a copy of the personal
          data we hold about you and our full list of
          third parties who process your data or to whom
          we disclosed your data for direct marketing
          purposes, and to check that we are lawfully
          processing your data.
        </li>
        <li>
          request confirmation as to whether or not your
          personal data is being processed.
        </li>
        <li>
          request the correction of your personal data
          that you consider to be inaccurate. This enables
          you to have any incomplete or inaccurate data we
          hold about you corrected. However, we may need
          to verify your identity and the accuracy of the
          new data you provide to us.
        </li>
        <li>
          request erasure of your personal data. This
          enables you to ask us to delete or remove
          personal data, for example: i) where there is no
          good reason for us continuing to process it; ii)
          where you have successfully exercised your right
          to object to processing (see below); iii) where
          we may have processed your information
          unlawfully; iv) where we are required to erase
          your personal data to comply with local law.
          Note, however, that we may not always be able to
          comply with your request of erasure for specific
          legal reasons and our need to keep appropriate
          archives for our business operations. These
          reasons will be notified to you at the time of
          your request. In addition, as explained in
          Section 2.3, certain information may always be
          publicly available to others and other
          information is made publicly available to others
          by default.
        </li>
        <li>
          object to processing of your personal data. This
          enables you to object to the processing of your
          personal data if you feel it impacts on your
          fundamental rights and freedoms. For example,
          this can be where we are processing your
          personal data for direct marketing purposes. In
          some cases, we may have compelling legitimate
          grounds to process your information which can
          override your right to object.
        </li>
        <li>
          request restriction of processing of your
          personal data. This gives you the option to ask
          us to suspend the processing of your personal
          data in the following scenarios: i) if you want
          us to establish the data's accuracy; ii) where
          our use of the data is unlawful but you do not
          want us to erase it; iii) where you need us to
          hold the data, even if we no longer require it
          e.g. to establish or defend legal claims; or iv)
          you have objected to our use of your data but we
          need to verify whether we have overriding
          legitimate ground to use it.
        </li>
        <li>
          request transfer of your personal data. If you
          request us to do so, we will provide to you, or
          a third party of your choice, your personal data
          in a commonly used, machine-readable format.
          Note that this right only applies to automated
          information which you initially provided consent
          for us to use, or where we have used the
          information to perform a contract with you.
        </li>
        <li>
          withdraw consent to the processing of your data.
          If you request us to do so, we will no longer
          process your data. However, this will not affect
          the lawfulness of any processing carried out
          before you withdraw your consent. If you
          withdraw your consent, we may not be able to
          provide our Service for you. Also, we will
          advise you of this at the time you withdraw your
          consent.
        </li>
        <li>
          not have a decision made about you based solely
          on automated processing.
        </li>
      </ol>
      <p>
        If you wish to exercise any of the rights set out
        above or request details about the specific legal
        basis we are relying on to process your personal
        data, please email us at{' '}
        <a href="mailto:privacy@playboy.com">
          privacy@playboy.com
        </a>{' '}
        using the{' '}
        <a
          href="data:application/pdf;base64,JVBERi0xLjQKMSAwIG9iago8PAovVGl0bGUgKP7/KQovQ3JlYXRvciAo/v8p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"
          rel="noreferrer" target="_blank"
        >
          Subject Access Request Form
        </a>
        .
      </p>
      <p>
        We will respond to you within 30 days of receipt of
        your request. Occasionally it may take us longer
        than 30 days if your request is particularly complex
        or you have made a number of requests. In this case,
        we will notify you and keep you updated.
      </p>
      <p>
        We may need to request specific information from you
        to help us confirm your identity and ensure your
        right to access your personal data (or to exercise
        your other legal rights). This is a security measure
        to ensure that your personal data is not disclosed
        to any person who does not have the right to receive
        it. We may also contact you to ask you for further
        information, in relation to your request, to speed
        up our response.
      </p>
      <p>
        You will not have to pay a fee to access your
        personal data (or to exercise any of your other
        legal rights). However, we may charge a reasonable
        fee if your request is clearly unfounded, repetitive
        or excessive. Alternatively, we may refuse to comply
        with your request in these circumstances.
      </p>
      <p>
        You have the right to make a complaint at any time
        to the Information Commissioner's Office (ICO), the
        UK supervisory authority for data protection issues
        (www.ico.org.uk). We would, however, appreciate the
        chance to deal with your concerns before you
        approach the ICO so please email us at{' '}
        <a href="mailto:privacy@playboy.com">
          privacy@playboy.com
        </a>{' '}
        in the first instance.
      </p>
      <a name="s15" />
      <p className="h4">15. Data retention</p>
      <p>
        If you are located in the European Union, or if the
        GDPR otherwise applies to your data as processed by
        us, we will only retain your personal data for as
        long as necessary to fulfil the purposes for which
        we collected it, including for the purposes of
        satisfying any legal, accounting, or internal
        reporting requirements. To determine the appropriate
        retention period for personal data, we consider the
        amount, nature, and sensitivity of the personal
        data, the potential risk of harm from unauthorized
        use or disclosure of your personal data, the
        purposes for which we process your personal data and
        whether we can achieve those purposes through other
        means, and the applicable legal requirements.
      </p>
      <p>
        In some circumstances we may anonymize your personal
        data (so that it can no longer be associated with
        you) for compliance, governance, legal and/or
        regulatory purposes in which case we may use this
        information indefinitely without further notice to
        you.
      </p>
      <a name="s16" />
      <p className="h4">
        16. Cooperation with law enforcement; fraud
        protection
      </p>
      <p>
        We fully cooperate with law enforcement agencies in
        identifying those who use our Website or Service for
        illegal activities. We reserve the right to disclose
        information about members who we believe are in
        violation of applicable laws or regulations, or as
        required to respond to a subpoena, court orders or
        other legal process requiring such disclosure. We
        also reserve the right to report to law enforcement
        agencies any activities that we reasonably believe
        to be unlawful and to exchange information with
        other companies and organizations for fraud
        protection.
      </p>
      <a name="s17" />
      <p className="h4">17. Changes to this Privacy Policy</p>
      <p>
        Occasionally we may, in our discretion, make changes
        to this Privacy Policy. When we make material
        changes to this Privacy Policy, we'll provide you
        with prominent notice as appropriate under the
        circumstances, e.g. by displaying a prominent notice
        within the Website or by sending you an email. In
        some cases, we will notify you in advance, and your
        continued use of the Website after the changes have
        been made will constitute your acceptance of the
        changes. Please therefore make sure you read any
        such notice carefully. If you object to any of the
        changes, you have the opportunity to delete your
        account and any associated information. Once deleted
        your details will be non-recoverable.
      </p>
      <p>
        Please note that if you opt out of receiving notices
        from us, change notices will still govern your use
        of the Website, and you are responsible for
        reviewing such legal notices for changes, as posted
        on the Website.
      </p>
      <a name="s18" />
      <p className="h4">18. Who we are</p>
      <p>
        For the purposes of the GDPR, Playboy.com, Inc., an
        corporation with its principal offices located 10960
        Wilshire Blvd #2200 Los Angeles, CA 90024 is the
        Data Controller and is responsible for your personal
        data. This means that we determine the purposes and
        ways of the processing of your personal data
      </p>
    </div>
  </div>
);

export default NudeNewsPrivacyPolicy;
